import { ComponentType } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from './error-fallback';

interface HandleErrorInfo {
    componentStack?: string | null;
}

type OnErrorHandler = (error: Error, info: HandleErrorInfo) => void;
type OnResetHandler = (...args: Array<unknown>) => void;

const withErrorComponent = (
    Component: ComponentType,
    onError?: OnErrorHandler,
    onReset?: OnResetHandler,
) => {
    const handleError = (error: Error, { componentStack }: HandleErrorInfo) => {
        if (onError) {
            return onError(error, { componentStack });
        }

        console.error('Component Stack: ', componentStack);
    };

    const handleReset = () => {
        if (onReset) {
            return onReset();
        }

        window.location.pathname = '/';
    };

    return withErrorBoundary(Component, {
        FallbackComponent: ErrorFallback,
        onError: handleError,
        onReset: handleReset,
    });
};

export { withErrorComponent };
